<div class="hero is-fullheight">
	<div class="hero-body">
		<div class="container">
			<!-- Buttons -->
			<div class="columns">
				<p class="control column">
					<a
					(click)="selectArea(courseAreas.management)"
					[class.is-link]="selectedArea === courseAreas.management"
					class="button">
					Gestión y mejora
					</a>
				</p>
				<p class="control column">
					<a
						(click)="selectArea(courseAreas.metrology)"
						[class.is-link]="selectedArea === courseAreas.metrology"
						class="button">
						Metrología
					</a>
				</p>
				<p class="control column">
					<a
						(click)="selectArea(courseAreas.humanResources)"
						[class.is-link]="selectedArea === courseAreas.humanResources"
						class="button">
						Recursos humanos
					</a>
				</p>
			</div>

			<!-- Courses -->
			<div class="table-container">
				<table class="table">
					<thead>
						<tr>
							<th>Código</th>
							<th>Descripción del curso</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let course of (filteredCourses | async)">
							<th>{{ course.code }}</th>
							<td>{{ course.description }}</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>		
	</div>
</div>

<!-- Form -->
<app-contact-form [isCourseForm]="true"></app-contact-form>
